import React from "react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { mapNationalityForFormSelect } from "@utils";
import { CountryDataType } from "@data-types/membership/registration";

export default function OnboardingRegistrationNationality(props: {
	countryData: CountryDataType[] | null;
	labelClassName?: string;
}) {
	const { countryData, labelClassName } = props;

	return (
		<FormSelectField
			name="nationality"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:NATIONALITY_LABEL"
			inputClassName="input input--sml input--select"
			placeholder="registration:NATIONALITY_PLACEHOLDER"
			dropdownData={mapNationalityForFormSelect(countryData)}
			required
		/>
	);
}
